import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { type CategorySelectorState } from '@/views/build/features/category-select-view';
import { MobileCategorySingleSelect } from '../../category-select-view/components/MobileCategorySingleSelect';

/**
 * 학습 분야 선택 모바일 컴포넌트
 *
 * 선택된 과목의 하위 학습 분야(subSubject)를 선택할 수 있는 SingleSelect 컴포넌트입니다.
 * 과목이 선택되지 않았거나 하위 학습 분야가 없는 경우 비활성화됩니다.
 */
export const SubSubjectMobileSelection = ({
  categoryInfo
}: {
  categoryInfo: CategorySelectorState;
}) => {
  const {
    t
  } = useTranslation(['common', 'build']);
  // 선택된 과목의 하위 노드가 있는지 확인
  const subNodes = categoryInfo.subject.selectedSubjectNode?.subNodes ?? [];
  const hasSubNodes = subNodes.length > 0;

  // 과목이 선택되지 않았거나 하위 노드가 없으면 비활성화
  const isDisabled = !categoryInfo.subject.selectedSubjectNode || !hasSubNodes;
  const placeholder = useMemo(() => {
    if (categoryInfo.subject.selectedSubjectNode && !hasSubNodes) return t('build:build.category.emptySubSubject');
    return t('common:category.subSubject');
  }, [hasSubNodes, categoryInfo.subject.selectedSubjectNode, t]);
  return <MobileCategorySingleSelect value={categoryInfo.subject.selectedSubSubjectNode?.nodeId || null} categoryNodes={subNodes} onValueChange={async value => {
    if (value != null) {
      categoryInfo.updateCategoryInfo(value);
    }
  }} placeholder={placeholder} error={false} disabled={isDisabled} data-sentry-element="MobileCategorySingleSelect" data-sentry-component="SubSubjectMobileSelection" data-sentry-source-file="SubSubjectMobileSelection.tsx" />;
};